import { Category } from '../models/category.ts';
import GenerateQuery from '../models/helpers/generateQuery.ts';
import { BaseSearchParam } from '../models/searchParams/baseSearchParam.ts';
import { TableSearchParam } from '../models/searchParams/tableSearchParam.ts';
import { ApiClient } from "./ApiClient.js";

const CategoriesController = {
    getAll: () => {
        let url = `categories`
        return ApiClient.get(url);
    },
    get: (tableSearchParam: TableSearchParam, baseSearchParam: BaseSearchParam) => {
        let url = `categories/${tableSearchParam.offset}/${tableSearchParam.limit}${GenerateQuery(baseSearchParam)}`;
        return ApiClient.get(url);
    },
    getByID: (id: number) => {
        return ApiClient.get(`category/${id}`);
    },
    post: (category: Category) => {
        return ApiClient.post('category', category);
    },
    put: (category: Category) => {
        return ApiClient.put(`category/${category.categoryID}`, category);
    },
    delete: (id: number) => {
        return ApiClient.delete(`category/${id}`)
    }
};
export default CategoriesController;